// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"_1pFUZI"};